import PropTypes from 'prop-types';
import officeLocationShape from './officeLocationShape';

export default PropTypes.shape({
	compliance: PropTypes.bool.isRequired,
	disclaimer: PropTypes.string,
	firmName: PropTypes.string,
	isComplianceParent: PropTypes.bool.isRequired,
	isFirmBrandingEnabled: PropTypes.bool.isRequired,
	phone: PropTypes.string,
	email: PropTypes.string,
	website: PropTypes.string,
	facebook: PropTypes.string,
	twitter: PropTypes.string,
	linkedin: PropTypes.string,
	locations: PropTypes.arrayOf(officeLocationShape)
});